/* eslint-disable i18next/no-literal-string */
import { Box, Typography } from '@mui/material';
import { memo } from 'react';

import useIntegrationSellerReqsPage from 'pages/IntegrationPage/hooks/useIntegrationSellerReqsPage';
import { MarkdownDisplay } from 'shared/ui/MarkdownDisplay';

export const IntegrationSellerReqsPage = memo(() => {
  const { markdown, loading, sellerId } = useIntegrationSellerReqsPage();

  return (
    <Box>
      <Typography component="h2" typography="openSans.h2">
        {'Integration Details'}
      </Typography>
      <MarkdownDisplay
        markdown={markdown}
        isLoading={loading}
        sellerId={sellerId}
      />
    </Box>
  );
});
